'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { useSlideAnimation } from '~/hooks/interaction/form/useSlideAnimation';

const SlideAnimationContext = createContext<ReturnType<typeof useSlideAnimation> | undefined>(undefined);

export const useSlideAnimationContext = () => {
  const context = useContext(SlideAnimationContext);
  if (!context) {
    throw new Error(
      'useSlideAnimationContext must be called within SlideAnimationProvider',
    );
  }
  return context;
};

export function SlideAnimationProvider({
  children,
  className,
}: PropsWithChildren<{
  className: string;
}>) {
  const value = useSlideAnimation(className);

  return (
    <SlideAnimationContext.Provider value={value}>
      {children}
    </SlideAnimationContext.Provider>
  );
}
